// frontend/src/pages/vmdetail/VMAgentStatusBanner.js
// Linha de status do agente QEMU no cabeçalho da VM:
//  - agente respondendo → SO + kernel (como antes)
//  - agente configurado na VM, VM ligada, sem resposta → aviso destacado (agente parado dentro do guest)
//  - agente não configurado → aviso discreto
//  - VM desligada sem resposta → nada (não dá para saber)
import React from 'react';

// 'stopped' só com confirmação positiva do backend (agentRunning === false, i.e. o Proxmox
// disse que o agente não roda). agentRunning true sem osinfo (só fsinfo respondeu) ou null
// (falha de permissão/rede do nosso lado) não acusa o guest: não mostra nada.
export function agentStatusKind(vm, agentInfo) {
  if (!agentInfo) return null;
  if (agentInfo.osInfo) return 'ok';
  if (agentInfo.agentConfigured === true) {
    if (vm?.status !== 'running') return null;
    return agentInfo.agentRunning === false ? 'stopped' : null;
  }
  if (agentInfo.agentConfigured === false) return 'missing';
  return 'missing'; // backend antigo (sem agentConfigured): comportamento anterior
}

export default function VMAgentStatusBanner({ vm, agentInfo }) {
  const kind = agentStatusKind(vm, agentInfo);
  if (!kind) return null;

  if (kind === 'ok') {
    return (
      <div className="agent-os-inline">
        <span className="agent-os-icon">🖥</span>
        <span className="agent-os-name">{agentInfo.osInfo.name}</span>
        {agentInfo.osInfo.kernel && (
          <span className="agent-os-kernel">
            <span className="agent-os-label">Kernel:</span> {agentInfo.osInfo.kernel}
          </span>
        )}
      </div>
    );
  }

  if (kind === 'stopped') {
    return (
      <div className="agent-stopped-banner" role="alert">
        <span className="agent-stopped-icon" aria-hidden="true">⚠️</span>
        <div className="agent-stopped-body">
          <strong>Agente QEMU instalado, mas parado</strong>
          <span className="agent-stopped-text">
            A VM está configurada com o agente QEMU, mas ele não está respondendo. Sem o agente, os backups são feitos sem consistência de arquivos,
            o painel não mostra IP, discos e sistema operacional, e travamentos parciais não são detectados.
            Inicie o serviço dentro da VM: no Windows, o serviço <code>QEMU Guest Agent</code>; no Linux, <code>systemctl start qemu-guest-agent</code>.
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="agent-missing-inline">
      <span className="agent-missing-icon">⚠️</span>
      <span className="agent-missing-text">Agente QEMU não configurado nesta VM</span>
    </div>
  );
}
